import api from "./friends";
const friends = {
  namespaced: true,
  state: {
    BOARD_CALENDAR: [],
    BOARD_A: [],
    BOARD_FILES: [],
    KAKAO_AUTH: [],
    EMPLOYEE_INFO: [],
    CLIENT_INFO: [],
    BRANCH_INFO: [],
  },
  getters: {
    GE_BOARD_CALENDAR: (state) => state.BOARD_CALENDAR,
    GE_BOARD_A: (state) => state.BOARD_A,
    GE_BOARD_FILES: (state) => state.BOARD_FILES,
    GE_KAKAO_AUTH: (state) => state.KAKAO_AUTH,
    GE_EMPLOYEE_INFO: (state) => state.EMPLOYEE_INFO,
    GE_CLIENT_INFO: (state) => state.CLIENT_INFO,
    GE_BRANCH_INFO: (state) => state.BRANCH_INFO,
  },

  mutations: {
    MU_BOARD_CALENDAR: (state, payload) => {
      state.BOARD_CALENDAR = payload.data;
    },
    MU_BOARD_A: (state, payload) => {
      state.BOARD_A = payload.data;
    },
    MU_BOARD_FILES: (state, payload) => {
      state.BOARD_FILES = payload.data;
    },
    MU_KAKAO_AUTH: (state, payload) => {
      state.KAKAO_AUTH = payload.data;
    },
    MU_EMPLOYEE_INFO: (state, payload) => {
      state.EMPLOYEE_INFO = payload.data;
    },
    MU_CLIENT_INFO: (state, payload) => {
      state.CLIENT_INFO = payload.data;
    },
    MU_BRANCH_INFO: (state, payload) => {
      state.BRANCH_INFO = payload.data;
    },
  },

  actions: {
    async BOARD_CALENDAR({ commit }, payload) {
      const response = await api.board_calendar(payload);
      commit("MU_BOARD_CALENDAR", response);
      return response;
    },
    async BOARD_A({ commit }, payload) {
      const response = await api.board_a(payload);
      commit("MU_BOARD_A", response);
      return response;
    },
    async BOARD_FILES({ commit }, payload) {
      const response = await api.board_files(payload);
      commit("MU_BOARD_FILES", response);
      return response;
    },
    async BOARD_FILES_DOWN({ commit }, payload) {
      const response = await api.board_files_down(payload);
      commit("MU_BOARD_FILES", response);
      return response;
    },
    async KAKAO_AUTH({ commit }, payload) {
      const response = await api.kakao_auth(payload);
      commit("MU_KAKAO_AUTH", response);
      return response;
    },
    async EMPLOYEE_INFO({ commit }, payload) {
      const response = await api.employee_info(payload);
      commit("MU_EMPLOYEE_INFO", response);
      return response;
    },
    async CLIENT_INFO({ commit }, payload) {
      const response = await api.client_info(payload);
      commit("MU_CLIENT_INFO", response);
      return response;
    },
    async BRANCH_INFO({ commit }, payload) {
      const response = await api.branch_info(payload);
      commit("MU_BRANCH_INFO", response);
      return response;
    },
  },
};

export default friends;
